import { useState } from "react";

export type ActionAreaType = "comment" | "goods";

const useActionAreaType = () => {
  const [actionAreaType, setActionAreaType] =
    useState<ActionAreaType>("comment");

  const handleChangeActionAreaType = (type: ActionAreaType) => {
    setActionAreaType(type);
  };

  return {
    actionAreaType,
    handleChangeActionAreaType,
  };
};

export default useActionAreaType;
